/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetScheduleEnabledRequestBody,
  SetScheduleEnabledRequestBody$Outbound,
  SetScheduleEnabledRequestBody$outboundSchema,
} from "../components/setscheduleenabledrequestbody.js";

export type SetAIIntegrationScheduleEnabledSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SetAIIntegrationScheduleEnabledRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setScheduleEnabledRequestBody: SetScheduleEnabledRequestBody;
};

/** @internal */
export type SetAIIntegrationScheduleEnabledSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetAIIntegrationScheduleEnabledSecurity$outboundSchema:
  z.ZodMiniType<
    SetAIIntegrationScheduleEnabledSecurity$Outbound,
    SetAIIntegrationScheduleEnabledSecurity
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setAIIntegrationScheduleEnabledSecurityToJSON(
  setAIIntegrationScheduleEnabledSecurity:
    SetAIIntegrationScheduleEnabledSecurity,
): string {
  return JSON.stringify(
    SetAIIntegrationScheduleEnabledSecurity$outboundSchema.parse(
      setAIIntegrationScheduleEnabledSecurity,
    ),
  );
}

/** @internal */
export type SetAIIntegrationScheduleEnabledRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  SetScheduleEnabledRequestBody: SetScheduleEnabledRequestBody$Outbound;
};

/** @internal */
export const SetAIIntegrationScheduleEnabledRequest$outboundSchema:
  z.ZodMiniType<
    SetAIIntegrationScheduleEnabledRequest$Outbound,
    SetAIIntegrationScheduleEnabledRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      setScheduleEnabledRequestBody:
        SetScheduleEnabledRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
        setScheduleEnabledRequestBody: "SetScheduleEnabledRequestBody",
      });
    }),
  );

export function setAIIntegrationScheduleEnabledRequestToJSON(
  setAIIntegrationScheduleEnabledRequest:
    SetAIIntegrationScheduleEnabledRequest,
): string {
  return JSON.stringify(
    SetAIIntegrationScheduleEnabledRequest$outboundSchema.parse(
      setAIIntegrationScheduleEnabledRequest,
    ),
  );
}
